"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeHeader = void 0;
var tslib_1 = require("tslib");
/**
 * @internal
 */
function sanitizeHeader(header) {
    // get rid of empty values in header altogether
    return (header && tslib_1.__assign(tslib_1.__assign({}, (header.description && { description: header.description })), (header.title && { title: header.title })));
}
exports.sanitizeHeader = sanitizeHeader;
//# sourceMappingURL=utils.js.map